/*
  UNLOCK YOUR POWER - direct checkout for product pages (added in duplicate theme only).
  Every product-page CTA (main ATC, sticky ATC, section ATC buttons, custom bundle/offer forms)
  skips the cart and goes straight to /checkout, always including Shipping Protection exactly once.

  Flow:
    1. POST /cart/clear.js (config clearCart) so checkout holds only this purchase + protection.
    2. Add the shopper's selection:
       - Shrine <product-form>: run the theme's own handleSubmit (keeps variant, quantity,
         quantity breaks / bundles, gifts, upsells, selling_plan, line-item properties).
       - Any other /cart/add form (e.g. custom bundle offer): POST its FormData to /cart/add.js.
    3. Add Shipping Protection if it is not already in the cart (never a 2nd line / qty > 1).
    4. Let cart apps (EasyGift free gifts etc.) settle briefly, re-check protection, go to /checkout.
*/
(function () {
  'use strict';
  if (window.__uypDirectCheckout) return;
  window.__uypDirectCheckout = true;

  var CFG = window.UYP_CHECKOUT || {};
  var SP_ID = Number(CFG.spVariantId || 0);
  var CLEAR_CART = CFG.clearCart !== false;
  var SETTLE_MIN = Number(CFG.settleMinMs || 1200);
  var SETTLE_MAX = Number(CFG.settleMaxMs || 4000);
  var LOG = '[UYP checkout]';

  var busy = false;
  var watchdog = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function api(path, opts) {
    opts = opts || {};
    var headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    if (opts.json !== undefined) headers['Content-Type'] = 'application/json';
    return fetch(root() + path, {
      method: opts.method || (opts.json !== undefined || opts.body ? 'POST' : 'GET'),
      credentials: 'same-origin',
      headers: Object.assign(headers, opts.headers || {}),
      body: opts.json !== undefined ? JSON.stringify(opts.json) : opts.body
    }).then(function (res) {
      return res.text().then(function (txt) {
        var data = null;
        try { data = txt ? JSON.parse(txt) : null; } catch (e) { data = null; }
        if (!res.ok || (data && data.status && Number(data.status) >= 400)) {
          var err = new Error((data && (data.description || data.message)) || ('HTTP ' + res.status));
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function getCart() { return api('cart.js?_uyp=' + Date.now()); }
  function clearCart() { return CLEAR_CART ? api('cart/clear.js', { json: {} }) : Promise.resolve(); }

  // Make sure Shipping Protection is in the cart exactly once (one line, quantity 1).
  function ensureProtection() {
    if (!SP_ID) return Promise.resolve();
    return getCart().then(function (cart) {
      var lines = (cart.items || []).filter(function (i) { return Number(i.variant_id) === SP_ID; });
      if (!lines.length) {
        return api('cart/add.js', { json: { items: [{ id: SP_ID, quantity: 1 }] } });
      }
      var chain = Promise.resolve();
      lines.forEach(function (line, idx) {
        var want = idx === 0 ? 1 : 0;
        if (Number(line.quantity) !== want) {
          chain = chain.then(function () {
            return api('cart/change.js', { json: { id: line.key, quantity: want } });
          });
        }
      });
      return chain;
    }).catch(function (e) {
      // One retry, then continue to checkout rather than block the sale.
      console.warn(LOG, 'shipping protection check failed, retrying', e);
      return sleep(400).then(function () {
        return api('cart/add.js', { json: { items: [{ id: SP_ID, quantity: 1 }] } });
      }).catch(function (e2) { console.error(LOG, 'could not add shipping protection', e2); });
    });
  }

  // Wait briefly for cart apps (e.g. EasyGift auto-add) to finish reacting to the add.
  function settle() {
    var start = Date.now();
    var lastSig = null;
    var stableSince = Date.now();
    function sig(c) {
      return (c.items || []).map(function (i) { return i.key + ':' + i.quantity; }).join('|');
    }
    function loop() {
      return getCart().then(function (c) {
        var s = sig(c);
        var now = Date.now();
        if (s !== lastSig) { lastSig = s; stableSince = now; }
        var elapsed = now - start;
        if ((elapsed >= SETTLE_MIN && now - stableSince >= 700) || elapsed >= SETTLE_MAX) return;
        return sleep(350).then(loop);
      }).catch(function () { /* ignore, go on */ });
    }
    return loop();
  }

  function goToCheckout() {
    console.log(LOG, 'redirecting to checkout');
    window.location.href = root() + 'checkout';
  }

  function finish() {
    return ensureProtection()
      .then(settle)
      .then(ensureProtection)
      .then(goToCheckout);
  }

  function setBusyUI(btn, on) {
    document.documentElement.classList.toggle('uyp-redirecting', !!on);
    if (!btn) return;
    btn.classList.toggle('loading', !!on);
    btn.classList.toggle('is-loading', !!on);
    // (aria-disabled is left to the theme: its handleSubmit refuses to run when it is set)
    var sp = btn.querySelector('.loading-overlay__spinner');
    if (sp) sp.classList.toggle('hidden', !on);
  }

  function release(btn) {
    busy = false;
    if (watchdog) { clearTimeout(watchdog); watchdog = null; }
    setBusyUI(btn, false);
  }

  function arm(btn) {
    busy = true;
    if (watchdog) clearTimeout(watchdog);
    watchdog = setTimeout(function () { console.warn(LOG, 'timeout, releasing'); release(btn); }, 25000);
  }

  function showFormError(form, msg) {
    var el = form.parentNode && form.parentNode.querySelector('.uyp-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'uyp-error';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'color:#c00;font-size:14px;margin:8px 0 0;text-align:center;';
      form.insertAdjacentElement('afterend', el);
    }
    el.textContent = msg || (window.cartStrings && window.cartStrings.error) || 'Something went wrong. Please try again.';
  }

  function inExcludedArea(el) {
    return !!(el.closest('quick-add-modal, cart-drawer, cart-notification, #upCart, .cart-drawer, [data-uyp-skip]'));
  }

  function isThemeProductForm(pf) {
    return pf && typeof pf.handleSubmit === 'function' && pf.form && !inExcludedArea(pf) &&
      pf.dataset.isCartUpsell !== 'true';
  }

  // ---- Path A: Shrine <product-form> (theme builds the exact line items) ----
  function runThemeForm(pf, triggerBtn) {
    if (busy) return;
    var submitBtn = pf.submitButton || pf.querySelector('[type="submit"]');
    if (!submitBtn || submitBtn.getAttribute('aria-disabled') === 'true' || submitBtn.disabled) return;
    var uiBtn = triggerBtn || submitBtn;
    arm(uiBtn);
    setBusyUI(uiBtn, true);

    var cartEl = pf.cart;
    var hadOwnRender = cartEl && Object.prototype.hasOwnProperty.call(cartEl, 'renderContents');
    var hadOwnErr = Object.prototype.hasOwnProperty.call(pf, 'handleErrorMessage');
    var protoErr = pf.handleErrorMessage;
    var done = false;

    function restore() {
      if (cartEl && !hadOwnRender) delete cartEl.renderContents;
      if (!hadOwnErr) delete pf.handleErrorMessage;
    }

    function onSuccess() {
      if (done) return; done = true;
      restore();
      setTimeout(function () { setBusyUI(uiBtn, true); }, 0); // theme's finally() clears loading
      finish().catch(function (e) { console.error(LOG, e); goToCheckout(); });
    }

    function onFail(msg) {
      if (done) return; done = true;
      restore();
      console.warn(LOG, 'add to cart failed:', msg);
      release(uiBtn);
    }

    pf.handleErrorMessage = function (msg) {
      var r = protoErr.apply(pf, arguments);
      if (msg) onFail(msg);
      return r;
    };

    var fakeEvent = { preventDefault: function () {}, currentTarget: uiBtn, target: uiBtn };

    clearCart().catch(function (e) { console.warn(LOG, 'cart clear failed', e); }).then(function () {
      if (cartEl && typeof cartEl.renderContents === 'function') {
        // Success hook: the theme calls cart.renderContents() after a successful add.
        cartEl.renderContents = function () { onSuccess(); };
        pf.handleSubmit(fakeEvent);
      } else {
        // No cart drawer on this page: theme's own skip-cart redirect; add protection first.
        return ensureProtection().then(function () {
          pf.skipCart = true;
          pf.handleSubmit(fakeEvent);
        });
      }
    }).catch(function (e) { console.error(LOG, e); onFail(e && e.message); });
  }

  // ---- Path B: any other product form posting to /cart/add (custom offer/bundle forms) ----
  function runGenericForm(form, triggerBtn) {
    if (busy) return;
    var btn = triggerBtn || form.querySelector('[type="submit"]');
    if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;
    arm(btn);
    if (typeof form.__uypSync === 'function') { try { form.__uypSync(); } catch (e) {} }
    var fd = new FormData(form);
    var params = new URLSearchParams();
    fd.forEach(function (v, k) {
      if (typeof v !== 'string') return;
      if (/selling_plan\]?$/.test(k) && v === '') return; // no empty selling plans
      params.append(k, v);
    });
    if (!params.get('id') && !Array.from(params.keys()).some(function (k) { return /^items\[/.test(k); })) {
      release(btn);
      return;
    }
    setBusyUI(btn, true);
    var oldErr = form.parentNode && form.parentNode.querySelector('.uyp-error');
    if (oldErr) oldErr.textContent = '';

    clearCart().catch(function (e) { console.warn(LOG, 'cart clear failed', e); }).then(function () {
      return api('cart/add.js', {
        body: params.toString(),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
      });
    }).then(function () {
      return finish();
    }).catch(function (e) {
      console.error(LOG, e);
      showFormError(form, e && e.message);
      release(btn);
    });
  }

  function formFromEvent(e) {
    var f = e.target;
    return f && f.tagName === 'FORM' ? f : null;
  }

  // Capture phase on window: runs before the theme's/section's own submit listeners.
  window.addEventListener('submit', function (e) {
    var form = formFromEvent(e);
    if (!form || inExcludedArea(form)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (!form.closest('#MainContent, main, .content-for-layout') && !form.closest('sticky-atc')) return;

    var pf = form.closest('product-form');
    if (pf && !isThemeProductForm(pf)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var submitter = e.submitter || null;
    if (pf) runThemeForm(pf, submitter);
    else runGenericForm(form, submitter);
  }, true);

  // Section "ATC" buttons (type=button) that the theme wires to the main product form.
  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[id^="SectionAtcBtn-"]');
    if (!btn || btn.disabled || inExcludedArea(btn)) return;
    var pf = document.querySelector('product-form.main-product-form');
    if (!isThemeProductForm(pf)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    runThemeForm(pf, btn);
  }, true);

  // Sticky ATC whose form="..." points at a product form that does not exist on this template
  // (templates that use the custom bundle offer instead of the buy-buttons block): route it to
  // the page's offer form, else the main product form.
  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('sticky-atc button[type="submit"], sticky-atc button.main-product-atc');
    if (!btn || btn.disabled || btn.form || inExcludedArea(btn)) return;
    var offerForm = document.querySelector('#MainContent .ss-offer__form, main .ss-offer__form');
    var pf = document.querySelector('product-form.main-product-form');
    if (!offerForm && !isThemeProductForm(pf)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (offerForm) runGenericForm(offerForm, btn);
    else runThemeForm(pf, btn);
  }, true);

  // Back/forward cache: reset any loading state if the shopper returns from checkout.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      busy = false;
      document.documentElement.classList.remove('uyp-redirecting');
      document.querySelectorAll('.loading, .is-loading').forEach(function (b) {
        if (b.matches('button, .button')) b.classList.remove('loading', 'is-loading');
      });
    }
  });

  window.UYPDirectCheckout = { ensureProtection: ensureProtection, config: CFG, version: '1.0.0' };
})();
